import PageHeader from "@/components/PageHeader";
import ConversionChart from "@/components/leads/ConversionChart";
import SourceStatsChart from "@/components/leads/SourceStatsChart";
import { useI18n } from "@/i18n/i18n";
import { BarChart3 } from "lucide-react";

/**
 * Dedicated analytics page for the CRM lead pipeline.
 * Extracted from the main Leads (Kanban) view to give the Kanban more visual space.
 */
export default function LeadsAnalytics() {
  const { t } = useI18n();
  return (
    <div className="space-y-6" data-testid="leads-analytics-page">
      <PageHeader
        title={t("leads_analytics_title")}
        subtitle={t("leads_analytics_subtitle")}
        icon={BarChart3}
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2">
          <ConversionChart />
        </div>
        <div className="lg:col-span-1">
          <SourceStatsChart days={90} />
        </div>
      </div>
    </div>
  );
}
